<template>
    <div class="main-content">
        <h1 v-translate>My Coupons</h1>
        <div class="main-content__my-coupons">
            <!-- // ZQ COUPON -->
            <div class="box balance-overview--coupon">
                <wallet-balance-and-pending endpoint="coupons/"/>
            </div>
            <!-- // ZQ COUPON -->

            <div class="my-coupons__container">
                <div v-for="coupon in coupons" :key="coupon.code" class="my-coupons__item">
                    <label>
                        <div class="form__checkbox">
                            <input v-model="coupon.checked" class="input--checkbox" type="checkbox"
                                   name="checkbox_example">
                            <span class="checkbox-text"></span>
                        </div>
                        <div class="my-coupons__code">{{coupon.code}}</div>
                        <div class="my-coupons__amount"><translate>Amount</translate>: <strong>
                            <money-format :value="coupon.value"/>
                        </strong></div>
                        <div class="my-coupons__expires"><translate>Expires</translate>: <strong>{{coupon.expires|moment('LL')}}</strong></div>
                    </label>
                </div>
            </div>

            <button @click="mergeCoupons()" class="button" v-bind:class="{'button--gray button--red-on-hover':checked_coupons.length<2, 'button--primary':checked_coupons.length>1}" v-translate>Merge selected coupons</button>


        </div>
        <div class="main-content__dashboard">
            <loyalty-bonus/>

            <loyalty-rewarding-plan/>
        </div>
    </div>
</template>

<script>
    import WalletBalanceAndPending from "../components/WalletBalanceAndPending";
    import axios from 'axios';
    import MoneyFormat from "../components/MoneyFormat";
    import {mapActions} from "vuex";
    import MergeCoupons from "./popups/MergeCoupons";
    import {EventBus} from "../event-bus";
    import LoyaltyBonus from "../components/my-coupons/LoyaltyBonus";
    import LoyaltyRewardingPlan from "../components/my-coupons/LoyaltyRewardingPlan";

    export default {
        name: 'MyCoupons',
        components: {WalletBalanceAndPending, MoneyFormat, LoyaltyRewardingPlan, LoyaltyBonus},
        data() {
            return {
                'loading': true,
                'coupons': []
            }
        },
        computed: {
            checked_coupons: function () {
                let c = [];
                for (let i = 0; i < this.coupons.length; i++) {
                    if (this.coupons[i].checked) {
                        c.push(this.coupons[i])
                    }
                }
                return c;
            }
        },
        methods: {
            fetchData: async function () {
                let coupons_url = process.env.VUE_APP_ZEEQUEST_URL + 'api/bbo/my-coupons/';
                this.coupons = (await axios.get(coupons_url)).data
                this.loading = false;
            },
            mergeCoupons: function () {
                if (this.checked_coupons.length > 1) {
                    this.setPopupPayload(this.checked_coupons)
                    this.openPopup(MergeCoupons);
                }
            },
            ...mapActions([
                'openPopup',
                'setPopupPayload'
            ])
        },
        created: function () {
            this.fetchData()
            EventBus.$on('coupons-merged',this.fetchData)
        },
        beforeDestroy: function() {
            EventBus.$off('coupons-merged')
        }
    }
</script>